module.exports = __webpack_public_path__ + "static/assets/07809ec6d13ffdff0b15e8a3804140d7.png";